import { render } from "./RolesView.vue?vue&type=template&id=7ed09324&scoped=true"
import script from "./RolesView.vue?vue&type=script&lang=js"
export * from "./RolesView.vue?vue&type=script&lang=js"

import "./RolesView.vue?vue&type=style&index=0&id=7ed09324&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed09324"]])

export default __exports__